import { Badge } from "@/components/ui/badge";
import { ArticleType } from "@/types/enums";
import { cn } from "@/lib/utils";

interface ArticleTypeBadgeProps {
  type: string;
  className?: string;
}

const TYPE_CONFIG: Record<
  string,
  {
    label: string;
    variant: "default" | "secondary" | "destructive" | "outline";
    className: string;
  }
> = {
  [ArticleType.BLOG]: {
    label: "BLOG",
    variant: "outline",
    className: "bg-blue-50 text-blue-800 border-blue-300",
  },
  [ArticleType.PREMIUM]: {
    label: "PREMIUM",
    variant: "default",
    className: "bg-purple-100 text-purple-800 border-purple-300",
  },
};

export function ArticleTypeBadge({ type, className }: ArticleTypeBadgeProps) {
  const config = TYPE_CONFIG[type.toUpperCase()];

  return (
    <Badge
      variant={config.variant}
      className={cn(config.className, className)}
      aria-label={`Type: ${config.label}`}
    >
      {config.label}
    </Badge>
  );
}
